var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" mt-1 rounded border"},[(_vm.series)?_c('vue-apex-charts',{ref:"chart",attrs:{"type":"area","height":"200","options":_vm.options.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }